import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import s from "./Login.module.css";
import { Button, Form, Input, notification } from "antd";
import { useLoginMutation } from "../../store/api/lumi/auth";

const data = [
    {
        id: 1,
        label: "username",
        placeholder: "Username",
        element: <Input />,
        rules: [{ required: true, message: "Please input your username!" }],
    },
    {
        id: 2,
        label: "password",
        placeholder: "Password",
        element: <Input.Password />,
        rules: [{ required: true, message: "Please input your password!" }],
    },
];

export const Login = ({ loginCallback }) => {
    const navigate = useNavigate();
    const [login, { isLoading }] = useLoginMutation();

    const handleSubmit = async (values) => {
        try {
            await login(values).unwrap();
            navigate("/projects", { replace: true });
        }  catch (e) {
            if (e.originalStatus === 401) {
                notification.error({
                    message: 'Login Failed',
                    description: 'User credentials invalid',
                    duration: 2.5,
                });
            }
            console.log(e);
        }
    };

    const formItems = useMemo(
        () =>
            data.map((el) => (
                <Form.Item
                    key={el.id}
                    rules={el.rules}
                    label={el.label}
                    name={el.label}
                >
                    {el.element}
                </Form.Item>
            )),
        []
    );

    return (
        <div className={s.wrapper}>
            <h1 className={s.title}>Luminoso Login</h1>
            <Form
                title="Luminoso Login"
                onFinish={handleSubmit}
                className={s.form}
                autoComplete="off"
            >

                {formItems}
                <Form.Item>
                    <Button
                        loading={isLoading}
                        htmlType="submit"
                        type="primary"
                    >
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};
